import request from "../utils/request";
/**
 * 屏蔽目标用户
 * https://yapi.gaoding.com/project/1536/interface/api/118442
 * @param {number} user_id
 * @returns {Promise<any|undefined>}
 */
export function blockUser({ user_id }) {
  return request({
    method: "post",
    url: "/dm/block",
    data: { user_id },
  });
}

/* 获取个人设置
 * https://yapi.gaoding.com/project/1536/interface/api/119213
 */
export async function getSettings() {
  return request({
    url: "/settings",
  });
}

/**
 * 修改个人设置
 * https://yapi.gaoding.com/project/1536/interface/api/116625
 */
export async function setSettings(data) {
  return request({
    method: "post",
    url: "/settings",
    data,
  });
}

/**
 * 修改个人关注的领域
 * @param {number[]} ids 领域ids
 * https://yapi.gaoding.com/project/1536/interface/api/116625
 */
export async function setFocusAreas(ids) {
  return setSettings({
    job_ids: ids,
  });
}

/**
 * 查询屏蔽的用户
 * https://yapi.gaoding.com/project/1536/interface/api/118450
 */

export async function getBlockPrivateMessages() {
  return request({
    url: "/dm/blocked",
  });
}

/**
 * 获取第三方头像
 * https://yapi.gaoding.com/project/1536/interface/api/121722
 */

export async function getThirdAvatar(query) {
  return request({
    url: "/refresh_avatar",
    query,
  });
}

/**
 * 取消屏蔽人员信息
 * https://yapi.gaoding.com/project/1536/interface/api/118448
 */
export async function cancelUnblockUser(user_id) {
  return request({
    method: "post",
    url: "/dm/unblock",
    data: {
      user_id,
    },
  });
}

/**
 * 修改密码
 * https://yapi.gaoding.com/project/1536/interface/api/118898
 */
export async function changePassword(password) {
  return request({
    method: "post",
    url: "/password/change",
    data: {
      password: {
        ...password,
      },
    },
  });
}

/**
 * 验证码校验
 * https://yapi.gaoding.com/project/1536/interface/api/118837
 */
export async function checkPhoneCaptcha(data) {
  return request({
    method: "post",
    url: "/check/captcha",
    data,
  });
}

/**
 * 绑定第三方帐号
 * https://yapi.gaoding.com/project/1536/interface/api/118852
 */
export async function bindThirdAccount(service, data) {
  return request({
    method: "post",
    url: `/bind/${service}`,
    data,
  });
}
/**
 * 解绑第三方帐号
 * https://yapi.gaoding.com/project/1536/interface/api/118852
 */
export async function unbindThirdAccount(service) {
  return request({
    method: "post",
    url: `/unbind/${service}`,
  });
}

/**
 * 手机号绑定
 */

export async function bindPhone(data, { ignoreMessage } = {}) {
  return request({
    method: "post",
    url: `/bind`,
    ignoreMessage,
    data,
  });
}

/**
 * 重新绑定手机号
 * https://yapi.gaoding.com/project/1536/interface/api/118852
 */

export async function rebindPhone(data) {
  return request({
    method: "post",
    url: `/rebind`,
    data,
  });
}

/**
 * 发送邮箱验证码
 */
export async function setEmailCaptcha(data) {
  return request({
    method: "post",
    url: `/email/captcha`,
    data,
    ignoreError: true,
  }).catch((err) => {
    if (err.response.data) {
      return err.response.data;
    } else {
      throw err;
    }
  });
}

/**
 * 邮箱验证码验证
 * https://yapi.gaoding.com/project/1536/interface/api/121900
 */
export async function emailVerify(data) {
  return request({
    method: "post",
    url: `/email/verify`,
    data,
    ignoreError: true,
  });
}

/**
 * 绑定邮箱
 * https://yapi.gaoding.com/project/1536/interface/api/118836
 */
export async function bindEmail(data) {
  return request({
    method: "post",
    url: `/bind/email`,
    data,
    ignoreError: true,
  });
}

// /email/check
/**
 * 绑定邮箱
 * https://yapi.gaoding.com/project/1536/interface/api/118836
 */
export async function emailCheck(data) {
  return request({
    url: `/email/check`,
    query: data,
  });
}

/**
 * 用户账号信息校验
 * https://yapi.gaoding.com/project/1536/interface/api/153571
 */

export async function userAccountVerify(data) {
  return request({
    method: "post",
    url: `/user/account/verify`,
    data,
  }).catch((err) => {
    if (err?.response?.data) {
      return err.response.data;
    } else {
      throw err;
    }
  });
}

/**
 * 用户主动注销
 * https://yapi.gaoding.com/project/1536/interface/api/146412
 */

export async function userCancel(data) {
  return request({
    method: "post",
    url: `/users/cancel`,
    data,
  });
}

/**
 * 注销检查
 * https://yapi.gaoding.com/project/1536/interface/api/203742
 * @returns {Promise<{check_result: boolean, cancel_companies: any[]}>}
 */
export async function userDeleteCheck() {
  return request({
    url: `/users/cancel/check`,
  });
}

/**
 * 恢复账号注销
 * https://yapi.gaoding.com/project/1536/interface/api/203745
 */
export async function recoveryUserCancel() {
  return request({
    method: "post",
    url: `/users/cancel/restore`,
  });
}
